import { KEY } from "@utils/enum";

export const headers = [
  { key: KEY.ORDER, label: "Ordem de Venda", width: "fit-content" },
  { key: KEY.CUSTOMER, label: "Cliente", width: "280px" },
  { key: KEY.PRODUCT, label: "Produto", width: "280px" },
  { key: KEY.QUANTITY, label: "Quantidade", width: "fit-content" },
];
